<template>
  <v-dialog persistent v-model="dialog" max-width="700">
    <v-form ref="areaForm" v-model="validArea" :lazy-validation="lazy">
      <v-card :loading="loading">
        <v-card-title class="headline">{{ (isNew) ? 'Area senza nome' : area.description }}</v-card-title>
        <v-card-subtitle>{{ (isNew) ? 'Crea una nuova Area' : `Modifica l'area ${area.description}` }}</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Codice</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-text-field v-model="area.code" placeholder="Codice area" :rules="codeRules" :counter=3 single-line filled dense required clearable></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: -25px;">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Descrizione</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-text-field v-model="area.description" placeholder="Descrizione area" :rules="descriptionRules" :counter=50 single-line filled dense required clearable></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="error.hasErrors">
            <v-col class="col-12" v-for="(e, i) in error.errors" :key="i">
              <v-alert dense outlined type="error"><strong>ATTENZIONE!</strong> {{ e }}</v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small dark color="red" @click="clear()">Annulla</v-btn>
          <v-btn small dark color="green" :disabled="!(validArea)" :loading="loading" @click="save()">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import apiRepository from '../../api/api-repository';

export default {
  name: 'AreaForm',
  props: [ 'isNew', 'area' ],

  data: ()=> ({
      lazy: true, // tipo di validazione del form.
      dialog: false, // flag della dialog.
      loading: false, // flag di caricamento.
      validArea: true, // flag di validità del form.
      error: { hasErrors: false, errors: new Array() }, // stato degli errori.

      codeRules: [
          (v)=> !!v || 'Codice area obbligatorio',
          (v)=> (v != undefined) ? (v.length == 3) || 'Il codice deve essere lungo 3 caratteri' : ''
      ],
      descriptionRules: [
          (v)=> !!v || 'Descrizione area obbligatoria',
          (v)=> (v != undefined) ? (v.length < 50) || 'La descrizione non può essere maggiore di 50 caratteri' : '',
          (v)=> (v != undefined) ? (v.length > 3) || 'La descrizione non può essere inferiore a 3 caratteri' : ''
      ]
  }),

  methods: {
    open(){
      this.validArea = true; // setto il flag di validità del form.
      this.error = { hasErrors: false, errors: new Array() }; // resetto il box degli errori.
      // se esiste la referenza del form, lo resetto.
      if(this.$refs.areaForm) this.$refs.areaForm.resetValidation(); // resetto la validazione del form.
      // apro il form di creazione.
      this.dialog = true; // apro la dialog.
    },

    clear(){
      this.$refs.areaForm.resetValidation(); // resetto la validazione del form.
      this.error = { hasErrors: false, errors: new Array() }; // resetto il box degli errori.
      this.dialog = false; // chiudo la dialog.
    },

    async save(){
      // se il form non è valido, esco dal salvataggio.
      if(!this.$refs.areaForm.validate()) return;
      // form valido, proseguo con il salvataggio.
      this.loading = true; // setto il form in caricamento.

      try{
        let req = { 
          id: (this.area.id) ? this.area.id : null, 
          code: this.area.code, 
          description: this.area.description 
        };

        let res = (this.isNew) ? await apiRepository.area().create(req) : await apiRepository.area().update(req);
        // aggiorno lo stato della dialog.
        this.loading = false; // disabilito il caricamento.
        this.clear(); // chiudo la dialog.
        // emetto l'evento di salvataggio riuscito.
        this.$emit('saved', res); // restituisco il risultato agli ascoltatori.
      }
      catch(e){
        this.loading = false; // disabilito il caricamento.
        this.error.hasErrors = true; // abilito il box degli errori.
        this.error.errors = e.errors; // aggiorno la lista degli errori.
      }
    }
  }
}
</script>